module.exports = __webpack_public_path__ + "assets/a530363ea0d217a7151901ce665308f4.mp3";